<template>
  <div
    id="mainPage"
    :class="{ 'grayed-out': showModal }"
    class="container-fluid p-0"
    style="margin: 0; padding: 0"
  >
    <div
      class="row"
      style="
        margin: 0;
        padding: 0;
        text-align: left;
        width: 100%;
        margin: 0;
        background-color: #fff;
        height: 100%;
      "
    >
      <div
        class="col-xs-12"
        style="text-align: left; width: 100%; background-color: #fff"
      >
        <div class="row" style="margin: 0; padding: 0">
          <div
            class="col-1"
            style="width: 10px; min-width: 10px; max-width: 10px"
          ></div>
          <!-- <div
            class="col-10"
            style="text-align: left; width: 1200px; max-width: 1200px"
          >
            <div class="row">
              <div class="col-12 headerPanel">
                <div class="row">
                  <div class="col-12 headerInfoBox">
                    <div class="header-area-right">
                      <div class="col-6 header-login-main">
                        <div class="eye-and-link">
                          <div class="headerLoginBox" style="text-align: right">
                            <img class="eye" src="../assets/icons/Badge.svg" />
                          </div>
                          <router-link class="my-badges-link" to="/badges">
                            My Badges & Certificates (<span
                              :ref="totalBadgesComplete"
                              >{{ totalBadgesComplete }}</span
                            >)
                          </router-link>
                        </div>
                        <span
                          class="headerRefreshBox01"
                          ref="header_refresh_message"
                          v-if="!isRefreshingProgress"
                        >
                          Updating...
                        </span>

                        <span
                          class="headerRefreshBox02"
                          ref="header_refresh_message"
                          v-if="isRefreshingProgress"
                        >
                          Updating...
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="header-area-left">
                  <div class="col-4 faPanel">
                    <div class="my-progress">
                      <div class="myCourseProgress">My Course Progress</div>
                    </div>
                    <p class="p-topic-select">Select a topic</p>
                    <select
                      class="select-dropdown"
                      v-model="currentFaKey"
                      @change="shiftFuncArea($event.target.value)"
                    >
                      <option
                        v-for="(faInfo, faSortKey) in filteredProgressData"
                        :key="`${faSortKey}`"
                        :value="faInfo.faKey"
                      >
                        {{ faInfo.funcAreaTitle }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div
            class="col-10"
            style="text-align: left; width: 1200px; max-width: 1200px"
          >
            <div class="row">
              <div class="col-12 headerPanel">
                <div class="row">
                  <div class="col-12 headerInfoBox">
                    <div class="row">
                      <div class="my-progress">
                        <div class="myCourseProgress">My Course Progress</div>
                      </div>

                      <div class="col-6 header-login-main">
                        <div class="eye-and-link">
                          <div class="headerLoginBox" style="text-align: right">
                            <img class="eye" src="../assets/icons/Badge.svg" />
                          </div>
                          <!-- <router-link class="my-badges-link" to="/badges">
                            My Badges & Certificates (<span
                              :ref="totalBadgesComplete"
                              >{{ totalBadgesComplete }}</span
                            >)
                          </router-link> -->
                          <a
                            class="my-badges-link"
                            href="#"
                            @click.prevent="openModal"
                          >
                            My Badges & Certificates (<span
                              :ref="totalBadgesComplete"
                              >{{ totalBadgesComplete }}</span
                            >)
                          </a>
                          <!-- <b-modal
                            v-model="showModal"
                            id="badges-modal"
                            modal-class="badges-modal-class"
                            hide-footer
                            hide-header
                          >
                            <BadgesPage @close="showModal = false" />
                          </b-modal> -->
                          <div
                            v-if="showModal"
                            class="backdrop"
                            @click.self="closeModal"
                          ></div>
                          <div
                            class="modal"
                            style="display: block; z-index: 9999"
                            v-if="showModal"
                            @click.self="closeModal"
                          >
                            <div class="modal-content">
                              <BadgesPage
                                v-if="showModal"
                                @close="closeModal"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          class="refresh-box-holder"
                          style="position: relative"
                        >
                          <span
                            class="headerRefreshBox01"
                            ref="header_refresh_message"
                            v-if="isRefreshingProgress"
                          >
                            Updating...
                          </span>

                          <span
                            class="headerRefreshBox02"
                            ref="header_refresh_message"
                            v-if="!isRefreshingProgress"
                          >
                            Updating...
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 faPanel">
                    <p class="p-topic-select">Select a topic</p>
                    <select
                      class="select-dropdown"
                      v-model="currentFaKey"
                      @change="shiftFuncArea($event.target.value)"
                    >
                      <!-- <option
                        v-for="(faInfo, faSortKey) in filteredProgressData"
                        :key="`${faSortKey}`"
                        :value="faInfo.faKey"
                        class="select-option"
                      >
                        {{ faInfo.funcAreaTitle }}
                      </option> -->
                      <option
                        v-for="(faInfo, faSortKey) in filteredFuncArea"
                        :key="faSortKey"
                        :value="faInfo.faKey"
                        class="select-option"
                      >
                        {{ faInfo.funcAreaTitle }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1" style="width: 10px; max-width: 10px"></div>
        </div>

        <!--
                BADGES section push
                -->
        <div
          class="row"
          style="text-align: left; width: 100%; margin: 0; overflow: hidden"
        >
          <div class="col-xs-12 badgeData">
            <div class="row">
              <div
                class="col-1"
                style="width: 10px; min-width: 10px; max-width: 10px"
              ></div>
              <div
                class="col-10"
                style="
                  text-align: left;
                  width: 1120px;
                  min-width: 1120px;
                  max-width: 1100px;
                "
              >
                <div
                  v-for="(faInfo, faSortKey) in filteredProgressData"
                  :key="`${faSortKey}`"
                  v-show="faInfo.showBadges"
                >
                  <!-- <div class="col-12 faGroupBox"> -->
                  <div
                    :class="
                      faInfo.faKey === currentFaKey
                        ? 'col-12 faGroupBox'
                        : 'col-12 faGroupBox'
                    "
                  >
                    <div class="row">
                      <div
                        v-for="(
                          badgeInfo, badgeSortKey, index
                        ) in faInfo.visibleBadges"
                        :key="`${badgeSortKey}-${index}`"
                      >
                        <div :class="selectBadgeGroupClass(badgeInfo)">
                          <div class="row">
                            <div class="col-12">
                              <div
                                class="badgeInfo"
                                :class="selectBadgeInfoClass(badgeInfo)"
                                @click="toggleShowModules(badgeInfo.badgeKey)"
                              >
                                <div class="row">
                                  <div
                                    class="col-1 accordionChevronBox"
                                    @click.stop="
                                      toggleShowModules(badgeInfo.badgeKey)
                                    "
                                  >
                                    <img
                                      class="accordionChevron"
                                      :id="`chevron_${badgeInfo.badgeKey}`"
                                      :ref="`chevron_${badgeInfo.badgeKey}`"
                                      :src="
                                        require(`../assets/icons/chevdown_default.svg`)
                                      "
                                    />
                                  </div>
                                  <div class="col-5 badgeNameBox">
                                    <!-- <div class="faName">
                                      {{ faInfo.funcAreaTitle }}
                                    </div> -->
                                    <div class="badgeName">
                                      {{ badgeInfo.badgeName }}
                                    </div>
                                    <div class="badgeDate">
                                      {{
                                        getYearFromTimestamp(
                                          badgeInfo.createdDate
                                        )
                                      }}
                                      Edition
                                    </div>
                                  </div>
                                  <div class="col-4 badgeProgressBox">
                                    <div class="progressBoxText">
                                      {{ badgeInfo.moduleCompleteCount }}/{{
                                        badgeInfo.moduleCount
                                      }}
                                      Modules Completed
                                    </div>
                                    <div class="row">
                                      <div class="col-10 badgeCompleteBox">
                                        <div class="progressBar">
                                          <div
                                            class="progressBarComplete"
                                            :style="{
                                              width: badgeInfo.pctBadgeComplete,
                                            }"
                                          ></div>
                                        </div>
                                      </div>
                                      <!-- <div
                                        class="col-2 badgePercentCompleteBox"
                                      >
                                        {{ badgeInfo.pctBadgeComplete }}
                                      </div> -->
                                    </div>
                                  </div>
                                  <div class="col-1 badgeIcon">
                                    <img
                                      class="badgeFile"
                                      :id="badgeSortKey"
                                      :ref="`${badgeSortKey}`"
                                      :src="
                                        require(`../assets/badges/${badgeInfo.badgeFile}.svg`)
                                      "
                                    />
                                  </div>
                                  <div class="col-2 updatedContentBox"></div>
                                </div>
                              </div>
                              <div class="row">
                                <transition name="fade">
                                  <div
                                    class="col-12"
                                    v-show="badgeInfo.showModules"
                                  >
                                    <div
                                      v-for="(
                                        moduleInfo, moduleSortKey
                                      ) in badgeInfo.progress_module_sort_dict"
                                      :key="`${moduleSortKey}`"
                                    >
                                      <div class="module-row">
                                        <div class="col-12 moduleGroupBox">
                                          <div
                                            class="moduleInfo"
                                            @click="
                                              toggleShowUnits(
                                                moduleInfo.moduleKey
                                              )
                                            "
                                          >
                                            <div class="row">
                                              <div
                                                class="col-1 accordionPlusBox"
                                              >
                                                <img
                                                  class="accordionPlus"
                                                  :id="`plus_${moduleInfo.moduleKey}`"
                                                  :ref="`plus_${moduleInfo.moduleKey}`"
                                                  @mouseover="
                                                    hoverPlusIcon(
                                                      moduleInfo,
                                                      true
                                                    )
                                                  "
                                                  @mouseleave="
                                                    hoverPlusIcon(
                                                      moduleInfo,
                                                      false
                                                    )
                                                  "
                                                  :src="
                                                    require(`../assets/icons/plus_default.svg`)
                                                  "
                                                  @click.stop="
                                                    toggleShowUnits(
                                                      moduleInfo.moduleKey
                                                    )
                                                  "
                                                />
                                              </div>
                                              <div class="moduleTitleBox">
                                                {{ moduleInfo.moduleTitle }}
                                              </div>
                                              <div
                                                class="col-4 moduleProgressBox"
                                              >
                                                <div
                                                  class="progressBoxText-unit"
                                                >
                                                  {{
                                                    moduleInfo.unitCompleteCount
                                                  }}/{{ moduleInfo.unitCount }}
                                                  Units Completed
                                                  <!-- {{
                                                    badgeInfo.moduleCompleteCount
                                                  }}/{{ badgeInfo.moduleCount }} -->
                                                  <!-- 0/0 Units Completed -->
                                                </div>
                                                <div class="row">
                                                  <div
                                                    class="col-10 moduleCompleteBox"
                                                  >
                                                    <div
                                                      class="unit-progressBar"
                                                    >
                                                      <div
                                                        class="progressBarComplete"
                                                        :style="{
                                                          width:
                                                            moduleInfo.pctModuleComplete,
                                                        }"
                                                      ></div>
                                                    </div>
                                                  </div>
                                                  <!-- <div
                                                    class="col-10 modulePercentCompleteBox"
                                                  >
                                                    {{
                                                      moduleInfo.pctModuleComplete
                                                    }}
                                                  </div> -->
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="unit-row">
                                            <div
                                              class="col-12 unitGroupBox"
                                              v-show="moduleInfo.showUnits"
                                            >
                                              <div
                                                v-for="(
                                                  unitInfo, unitSortKey
                                                ) in moduleInfo.progress_unit_sort_dict"
                                                :key="`${unitSortKey}`"
                                              >
                                                <div
                                                  class="unit-complete-progress"
                                                >
                                                  <div class="col-12 unitInfo">
                                                    <div
                                                      class="unit-progress-section"
                                                    >
                                                      <div
                                                        class="col-2 unitCompleteBox"
                                                      >
                                                        <img
                                                          v-if="
                                                            unitInfo.isUnitComplete
                                                          "
                                                          src="../assets/icons/Check.svg"
                                                        />
                                                        <img
                                                          v-if="
                                                            !unitInfo.isUnitComplete
                                                          "
                                                          src="../assets/icons/old_plus_active.svg"
                                                        />
                                                      </div>
                                                      <!-- <div
                                                        class="col-2 unitCompleteBox"
                                                      >
                                                        <img
                                                          :src="
                                                            unitInfo.isUnitComplete
                                                              ? '../assets/icons/Check.svg'
                                                              : '../assets/icons/old_plus_active.svg'
                                                          "
                                                        />
                                                      </div> -->
                                                      <div
                                                        class="col-10 unitTitleBox"
                                                      >
                                                        {{ unitInfo.unitTitle }}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </transition>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
</template>

<script>
import * as axios from "axios";
import BadgesPage from "/source/web/src/components/BadgesPage";
//import langFileEs from "/source/lang_files/lang.es.json";

export const authHeader = { Authorization: "Bearer {token}" };
const { jwt_decode } = require("../jwt.js");
const settings = require("/ps_settings/config.json");

// console.log("TestingTesting2");

export default {
  name: "MainPage",
  data() {
    let langChoice = this.$cookies.get("langChoice");
    let newLang;
    let newLangTitle;
    if (this.$store.state.langChoice === "en") {
      newLang = "es";
      newLangTitle = "Español";
    } else {
      newLang = "en";
      newLangTitle = "English";
    }
    if (!this.$store.currentFaKey) {
      this.$store.currentFaKey = "adv";
      this.currentFaKey = this.$store.currentFaKey;
    } else {
      this.currentFaKey = this.$store.currentFaKey;
    }
    return {
      showModal: false,
      envVars: process.env,
      newLang: newLang,
      newLangTitle: newLangTitle,
      progressData: this.$store.progressData,
      currentFaKey: this.$store.currentFaKey,
      isRefreshingProgress: false,
      store: this.$store,
      lastName: "",
      firstName: "",
      sis_user_id: "",
      totalBadgesComplete: this.$store.totalBadgesComplete,
      isRefreshed: this.$store.isRefreshed,
      iconChevronClosed: require("../assets/icons/chevdown_default.svg"),
      iconChevronClosedHover: require("../assets/icons/chevdown_hover.svg"),
      iconChevronOpen: require("../assets/icons/chevup_active.svg"),
      iconChevronOpenHover: require("../assets/icons/chevup_active_hover.svg"),
      isChevronHover: false,
      isPlusDownHover: false,
      badgeSelectionList: [],
      currentBadgeKey: "",
      currentModuleKey: "",
      filteredBadgeDisplayList: [],
      newObject: {},
      filteredObject: {},
      consolidatedObject: {},
      filteredProgressData: {},
    };
  },
  props: {
    msg: String,
  },
  components: {
    BadgesPage,
  },

computed: {
  filteredFuncArea() {
    if (!this.filteredProgressData) return {};
    let result = {};
    for (const [faSortKey, faInfo] of Object.entries(this.filteredProgressData)) {
      if (faInfo.faActive) {
        result[faSortKey] = faInfo;
      }
    }
    return result;
  }
  // activeFaOptions() {
  //   if (!this.filteredProgressData) return [];
  //   return Object.values(this.filteredProgressData).filter(faInfo => faInfo.faActive === true);
  // }
  // filteredProgressDataFaActive() {
  //   let result = {};
  //   for (const [faSortKey, faInfo] of Object.entries(this.filteredProgressData || {})) {
  //     if (faInfo.faActive === true) {
  //       result[faSortKey] = faInfo
  //     }
  //   }
  //   return result;
  // }
  // faActiveDropdownOptions() {
  //   return Object.values(this.filteredProgressData || {}).filter(fa => fa.faActive);
  // }
},

  methods: {
    openModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    test_ltiAuthenticate() {
      this.$store.lastName = "Macdonald";
      this.$store.firstName = "Norm";
      this.$store.sis_user_id = "5d2cb5d3f169430568541432";
      this.lastName = "Macdonald";
      this.firstName = "Norm";
      this.sis_user_id = "5d2cb5d3f169430568541432";
    },
    ltiAuthenticate() {
      // let ltiAuthCookie = window.$cookies.get("ltiProgress");
      // let credentials = jwt_decode(ltiAuthCookie);
      // this.$store.lastName = credentials.family_name;
      // this.$store.firstName = credentials.given_name;
      // this.$store.sis_user_id = credentials.sis_user_id;
      // console.log("STORE VALUES:: ");
      // console.log("sis_user_id", this.$store.sis_user_id);
      // console.log("lastName", this.$store.lastName);
      // console.log("firstName", this.$store.firstName);
      this.lastName = this.$store.lastName;
      this.firstName = this.$store.firstName;
      this.sis_user_id = this.$store.sis_user_id;
    },
    selectBadgeGroupClass(badgeInfo) {
      if (
        badgeInfo.badgeKey === this.currentBadgeKey &&
        !badgeInfo.showModulesState
      ) {
        return "col-12 badgeGroupBoxActive";
      } else {
        return "col-12 badgeGroupBoxDefault";
      }
    },
    selectBadgeInfoClass(badgeInfo) {
      return badgeInfo.badgeKey === this.currentBadgeKey &&
        !badgeInfo.showModulesState
        ? "active"
        : "";
    },
    getIconChevronOpen(badgeInfo) {
      if (badgeInfo.badgeKey === this.currentBadgeKey) {
        if (this.isChevronHover) {
          return this.iconChevronOpenHover;
        } else {
          return this.iconChevronOpen;
        }
      } else {
        if (this.isChevronHover) {
          return this.iconChevronClosedHover;
        } else {
          return this.iconChevronClosed;
        }
      }
    },
    getIconChevronClosed(badgeInfo) {
      if (badgeInfo.badgeKey === this.currentBadgeKey) {
        if (this.isChevronHover) {
          return this.iconChevronClosedHover;
        } else {
          return this.iconChevronClosed;
        }
      } else {
        if (this.isChevronHover) {
          return this.iconChevronOpenHover;
        } else {
          return this.iconChevronOpen;
        }
      }
    },
    getBadgesExpandState(inBadgeKey) {
      for (const [faSortKey, faInfo] of Object.entries(
        this.filteredProgressData
      )) {
        for (const [badgeSortKey, badgeInfoList] of Object.entries(
          faInfo.progress_badge_sort_dict
        )) {
          badgeInfoList.forEach((badgeInfo) => {
            if (badgeInfo.badgeKey === inBadgeKey) {
              return badgeInfo.showModules;
            } else {
              return false;
            }
          });
        }
      }
    },

    toggleShowModules(badgeKey) {
      this.currentBadgeKey = badgeKey;
      //console.log("Going to toggle modules for badgeKey:", badgeKey);
      for (const [faSortKey, faInfo] of Object.entries(
        this.filteredProgressData
      )) {
       // console.log("Processing this FA", faSortKey, faInfo)
        for (const [badgeSortKey, badgeInfoList] of Object.entries(
          faInfo.progress_badge_sort_dict
        )) {
          //console.log("badgeSortKey:", badgeSortKey, "badgeInfoList", badgeInfoList, "Type:", Array.isArray(badgeInfoList) ? 'Array' : typeof badgeInfoList)
          badgeInfoList.forEach((badgeInfo, idx) => {
            //console.log("badgeKey:", badgeInfo.badgeKey, "| $refs value:", this.$refs[`chevron_${badgeInfo.badgeKey}`]);
            if (badgeInfo.badgeKey == badgeKey) {
              badgeInfo.showModules = !badgeInfo.showModules;
              // this.$set(this.progressData[faSortKey].progress_badge_sort_dict[badgeSortKey], 'badgeInfo.showModules', ! badgeInfo.showModules);
              this.$set(
                badgeInfo,
                "badgeInfo.showModules",
                !badgeInfo.showModules
              );
              if (badgeInfo.showModules) {
                this.$refs[
                  `chevron_${badgeInfo.badgeKey}`
                ][0].src = require("../assets/icons/chevup_active.svg");
              } else {
                this.$refs[
                  `chevron_${badgeInfo.badgeKey}`
                ][0].src = require("../assets/icons/chevdown_default.svg");
              }
            } else {
              badgeInfo.showModules = false;
              this.$refs[
                `chevron_${badgeInfo.badgeKey}`
              ][0].src = require("../assets/icons/chevdown_default.svg");
            }
          });
        }
      }
      this.$forceUpdate();
    },

    toggleShowUnits(moduleKey) {
      this.currentModuleKey = moduleKey;
      for (const [faSortKey, faInfo] of Object.entries(
        this.filteredProgressData
      )) {
        for (const [badgeSortKey, badgeInfoList] of Object.entries(
          faInfo.progress_badge_sort_dict
        )) {
          badgeInfoList.forEach((badgeInfo) => {
            for (const [moduleSortKey, moduleInfo] of Object.entries(
              badgeInfo.progress_module_sort_dict
            )) {
              if (moduleInfo.moduleKey == this.currentModuleKey) {
                moduleInfo.showUnits = !moduleInfo.showUnits;
                this.$set(
                  moduleInfo,
                  "moduleInfo.showUnits",
                  !moduleInfo.showUnits
                );
                if (moduleInfo.showUnits) {
                  this.$refs[
                    `plus_${moduleInfo.moduleKey}`
                  ][0].src = require("../assets/icons/plus_active.svg");
                } else {
                  this.$refs[
                    `plus_${moduleInfo.moduleKey}`
                  ][0].src = require("../assets/icons/plus_default.svg");
                }
              } else {
                moduleInfo.showUnits = false;
                this.$refs[
                  `plus_${moduleInfo.moduleKey}`
                ][0].src = require("../assets/icons/plus_default.svg");
              }
            }
          });
        }
      }
      this.$forceUpdate();
    },

    hoverChevIcon(badgeInfo, hoverState) {
      if (badgeInfo.showModules) {
        if (hoverState) {
          this.$refs[
            `chevron_${badgeInfo.badgeKey}`
          ][0].src = require("../assets/icons/chevup_active_hover.svg");
        } else {
          this.$refs[
            `chevron_${badgeInfo.badgeKey}`
          ][0].src = require("../assets/icons/chevup_active.svg");
        }
      } else {
        if (hoverState) {
          this.$refs[
            `chevron_${badgeInfo.badgeKey}`
          ][0].src = require("../assets/icons/chevdown_hover.svg");
        } else {
          this.$refs[
            `chevron_${badgeInfo.badgeKey}`
          ][0].src = require("../assets/icons/chevdown_default.svg");
        }
      }
      this.$forceUpdate();
    },

    hoverPlusIcon(moduleInfo, hoverState) {
      if (moduleInfo.showUnits) {
        if (hoverState) {
          this.$refs[
            `plus_${moduleInfo.moduleKey}`
          ][0].src = require("../assets/icons/plus_active_hover.svg");
        } else {
          this.$refs[
            `plus_${moduleInfo.moduleKey}`
          ][0].src = require("../assets/icons/plus_active.svg");
        }
      } else {
        if (hoverState) {
          this.$refs[
            `plus_${moduleInfo.moduleKey}`
          ][0].src = require("../assets/icons/plus_hover.svg");
        } else {
          this.$refs[
            `plus_${moduleInfo.moduleKey}`
          ][0].src = require("../assets/icons/plus_default.svg");
        }
      }
      this.$forceUpdate();
    },

    shiftFuncArea(faKey) {
      for (const [faSortKey, faInfo] of Object.entries(
        this.filteredProgressData
      )) {
        if (faKey === faInfo.faKey) {
          this.currentFaKey = faInfo.faKey;
          this.$store.currentFaKey = faInfo.faKey;
          faInfo.showBadges = true;
          // this.$refs[faInfo.faKey][0].classList.value = "faTabActive";
        } else {
          faInfo.showBadges = false;
          // this.$refs[faInfo.faKey][0].classList.value = "faTabDefault";
        }
      }
    },
    currentData() {
      // url: `http://localhost:9001/current/${this.sis_user_id}`,
      const requestOptions = {
        url: `${settings.API_HOST}/current/${this.sis_user_id}`,
        method: "GET",
        headers: { "Access-Control-Allow-Origin": "*" },
        params: {},
      };
      //will modify this portion of code temporarily to modify filter here
      return axios(requestOptions)
        .then(async (res) => {
          //console.log('Headers', res.headers);
          //console.log('X-Data-Status header:', res.headers['x-data-status']);
          let resultData = res.data;
          let progressData = resultData[this.sis_user_id];
          // console.log("***********************************************************************");
          // console.log("***********************************************************************");
          // console.log("***********************************************************************");
          // console.log("Raw progress data from backend:", progressData);
          if (progressData) {
            this.$store.progressData = progressData;
            this.progressData = this.$store.progressData;
            this.filteredProgressData = await this.filterProgressBadgeSortDict(
              progressData
            );
            // console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
            // console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
            // console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
           // console.log("The filtered progress data============================>>>>>>>>");
          //  Object.entries(this.filteredProgressData).forEach(([faSortKey, faInfo]) => {
          //   console.log("faKey", faInfo.faKey, "| faInfo.visibleBadges:", faInfo.visibleBadges);
          //   if (Array.isArray(faInfo.visibleBadges)) {
          //     faInfo.visibleBadges.forEach((badge, badgeIdx) => {
          //       console.log(`  badge[${badgeIdx}] badgeKey:`, badge.badgeKey, "| progress_module_sort_dict:", badge.progress_module_sort_dict);
          //     });
          //   } else {
          //     console.log("visible badges are missing from this list or are not an array", faInfo.faKey);
          //   }
          //  });
           
            let totalBadgesComplete = 0;
            for (const [faSortKey, faInfo] of Object.entries(
              this.filteredProgressData
            )) {
              if (this.currentFaKey === faInfo.faKey) {
                faInfo.showBadges = true;
              } else {
                faInfo.showBadges = false;
              }
              for (const [badgeSortKey, badgeInfoList] of Object.entries(
                faInfo.progress_badge_sort_dict
              )) {
                badgeInfoList.forEach((badgeInfo) => {
                  if (badgeInfo.badgeKey === undefined) {
                    console.error(
                      "badgeInfo.badgeKey is undefined for badgeSortKey:",
                      badgeSortKey
                    );
                  }
                  if (this.currentBadgeKey === badgeInfo.badgeKey) {
                    badgeInfo.showModules = true;
                  } else {
                    badgeInfo.showModules = false;
                  }
                  this.badgeSelectionList.push({
                    badgeKey: badgeInfo.badgeKey,
                    showModules: badgeInfo.showModules,
                  });
                  if (badgeInfo.isBadgeComplete) {
                    badgeInfo.badgeFile = `badge_color_${badgeInfo.badgeKey}`;
                    totalBadgesComplete = totalBadgesComplete + 1;
                  } else {
                    badgeInfo.badgeFile = `badge_gray_${badgeInfo.badgeKey}`;
                  }
                  for (const [moduleSortKey, moduleInfo] of Object.entries(
                    badgeInfo.progress_module_sort_dict
                  )) {
                    if (this.currentModuleKey === moduleInfo.moduleKey) {
                      moduleInfo.showUnits = true;
                    } else {
                      moduleInfo.showUnits = false;
                    }
                  }
                });
              }
            }
            this.$store.totalBadgesComplete = totalBadgesComplete;
            this.totalBadgesComplete = totalBadgesComplete;
          }
          return res
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshData() {
      //console.log("The refreshData function was called.  Starting refresh now......");
      this.isRefreshingProgress = true;
      //console.log("At this point, isRefreshingProgress was toggled to true within the refreshData method");
      // url: `http://localhost:9001/current/${this.sis_user_id}`,
      const requestOptions = {
        url: `${settings.API_HOST}/refresh/${this.sis_user_id}`,
        method: "GET",
        headers: { "Access-Control-Allow-Origin": "*" },
        params: {},
      };
      axios(requestOptions)
        .then(async (res) => {
          //console.log("This is after ax call in refreshData");
          let resultData = res.data;
          let progressData = resultData[this.sis_user_id];
          if (progressData) {
            //console.log("Confirming that there is indeed progressData");
            this.$store.progressData = progressData;
            this.progressData = this.$store.progressData;
            this.filteredProgressData = await this.filterProgressBadgeSortDict(
              progressData
            );
            let totalBadgesComplete = 0;
            for (const [faSortKey, faInfo] of Object.entries(
              this.filteredProgressData
            )) {
              if (this.currentFaKey === faInfo.faKey) {
                faInfo.showBadges = true;
              } else {
                faInfo.showBadges = false;
              }
              for (const [badgeSortKey, badgeInfoList] of Object.entries(
                faInfo.progress_badge_sort_dict
              )) {
                badgeInfoList.forEach((badgeInfo) => {
                  if (this.currentBadgeKey === badgeInfo.badgeKey) {
                    badgeInfo.showModules = true;
                  } else {
                    badgeInfo.showModules = false;
                  }

                  if (badgeInfo.isBadgeComplete) {
                    totalBadgesComplete = totalBadgesComplete + 1;
                    badgeInfo.badgeFile = `badge_color_${badgeInfo.badgeKey}`;
                  } else {
                    badgeInfo.badgeFile = `badge_gray_${badgeInfo.badgeKey}`;
                  }

                  for (const [moduleSortKey, moduleInfo] of Object.entries(
                    badgeInfo.progress_module_sort_dict
                  )) {
                    if (this.currentModuleKey === moduleInfo.moduleKey) {
                      moduleInfo.showUnits = true;
                    } else {
                      moduleInfo.showUnits = false;
                    }
                  }
                });
              }
            }
            this.$store.totalBadgesComplete = totalBadgesComplete;
            this.totalBadgesComplete = totalBadgesComplete;
          }
          this.isRefreshingProgress = false;
          //console.log("This is where isRefreshingProgress should toggle to false from refreshData method");
          this.$store.isRefreshed = true;
          //console.log("Here is where store isRefreshed is true")
        })
        .catch((error) => {
          //console.log("if you see this, catch found an error =============================?????????????");
          console.log(error);
        })
        .finally(() => {
          //console.log("isRefrshingProgess toggle to false within the finally statement")
          this.isRefreshingProgress = false;
        });
    },
    async filterProgressBadgeSortDict(progressData) {
      let newProgressData = JSON.parse(JSON.stringify(progressData));
      for (const [faSortKey, faInfo] of Object.entries(newProgressData)) {
        faInfo.visibleBadges = [];
        for (const [badgeSortKey, badgeInfoList] of Object.entries(
          faInfo.progress_badge_sort_dict
        )) {
          badgeInfoList.forEach((badgeInfo) => {
            if (!badgeInfo.hasOwnProperty("badgeKey")) {
              //console.log("Missing badgeKey:", badgeInfo);
            }
            if (badgeInfo.primary !== false) {
              badgeInfo.showInUI = true;
              faInfo.visibleBadges.push(badgeInfo);
            } else {
              badgeInfo.showInUI = false;
            }
          });
        }
      }
      return newProgressData;
    },
    getYearFromTimestamp(timestamp) {
      let date = new Date(timestamp);
      return date.getFullYear();
    },
  },

  // async mounted() {
  // console.log("Mounted -- Beginning operations here =====================>>>>>>>>>>>");
  //   this.ltiAuthenticate();
  //   this.currentData();
  //   console.log("Is Refreshed?", this.$store.isRefreshed);
  //   if (!this.$store.isRefreshed) {
  //     console.log("Refreshing ***********************************************************");
  //     this.refreshData();
  //     this.isRefreshingProgress = true;
  //   } else {
  //     console.log("Refresh was not necessary XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX");
  //     this.isRefreshingProgress = false;
  //   }
  // },
  async mounted() {
    //console.log("mounted started *********")
    try {
      await this.ltiAuthenticate();
      //console.log("Im authenticated")
      await this.currentData();
      //console.log("All Fa's in in filteredProgressData");
      // Object.entries(this.filteredProgressData || {}).forEach(([k, fa]) => {
      //   console.log(`faKey: ${k}, Title: ${fa.funcAreaTitle}, faActive: ${fa.faActive}`)
      // })

      //console.log("active Fas in filteredProgressDataFaActive");
      // Object.entries(this.filteredProgressDataFaActive || {}).forEach(([k, fa]) => {
      //   console.log(`faKey: ${k}, Title: ${fa.funcAreaTitle}, faActive: ${fa.faActive}`)
      // })
      // console.log("=======================>>>>>>>>>>>>>>>>>>>>>>currentFaKey:", this.currentFaKey);
        if (!this.$store.isRefreshed) {
          await this.refreshData();
          //console.log("called refresh data from mounted...........");
          // Object.entries(this.filteredProgressData || {}).forEach(([k, fa]) => {
          //   console.log(`faKey: ${k}, Title: ${fa.funcAreaTitle}, faActive: ${fa.faActive}`)
          // })

          // console.log("active Fas in filteredProgressDataFaActive");
      //     Object.entries(this.filteredProgressDataFaActive || {}).forEach(([k, fa]) => {
      //       console.log(`faKey: ${k}, Title: ${fa.funcAreaTitle}, faActive: ${fa.faActive}`)
      // })
      // console.log("=======================>>>>>>>>>>>>>>>>>>>>>>currentFaKey:", this.currentFaKey);
          //this.isRefreshingProgress = true; 
        } else {
          //console.log("response status was not success")
          this.isRefreshingProgress = false;
          //console.log("is RefreshingProgress is false, from mounted");
        }
    } catch (error) {
      console.log("Error in mounted", error);
    }
  }
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/mainPage.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.accordionChevron {
  transform: rotate(-90deg);
  cursor: pointer;
  height: 8px;
  width: 8px;
  margin-top: -21px;
  margin-left: 10px;
}

.rotate0 {
  transform: rotate(0deg);
}

.badgeDate {
  font-size: 12px;
  // margin: -1px 0 0 -10px;
  font-family: $selectFontFamily;
  line-height: 14px;
  margin-top: 2px;
  margin-left: -30px;
  padding-bottom: 8px;
}

.badgeFile {
  height: 40px;
  margin-left: 9px;
  margin-top: -1px;
}

.badgeInfo {
  width: 700px;
  height: 56px;
  background-color: #f5f5f5;
  position: relative;
  cursor: pointer;
}

.badgeInfo::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 8px;
  background-color: #d9d9d9;
}

.badgeInfo.active::before {
  background-color: #d0e5fd;
}

// .badgeGroupBoxActive::before,
// .badgeGroupBoxDefault::before {
//   content: "";
//   position: absolute;
//   left: 0;
//   top: 0;
//   height: 100%;
//   width: 8px;
// }

// .badgeGroupBoxActive::before {
//   background-color: blue;
// }

// .badgeGroupBoxDefault::before {
//   background-color: #ccc;
// }

.badgeData {
  background-color: #fff;
  text-align: left;
  width: 100%;
}

.progressBoxText {
  font-size: 12px;
  line-height: 14px;
  width: 150px;
  // margin: 5px 0 1px 30px;
  color: #1e1e1e;
  margin-left: 74px;
  margin-top: 4px;
  margin-bottom: -5px;
}

.my-progress {
  padding: 0 0 0 0;
  height: 100px;
}

.module-row {
  width: 700px;
}

.unit-row {
  width: 648px;
}

.moduleGroupBox {
  // height: 53px;
  position: relative;
  font-family: "Open Sans SemiBold", sans-serif;
  font-size: 18px;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
  text-align: left;
  overflow: hidden;
  // border-top: 1px solid gray;
  // background-color: #f6faff;
}

.module-info-row {
  display: flex;
  flex-direction: row;
}

.unit-progressBar {
  width: 160px;
  height: 12px;
  background-color: #a0a0a0;
  border-radius: 10px;
  text-align: right;
  margin: -6px 0 -10px 12px;
  padding: 0 0 0 0;
}

.header-login-main {
  display: flex;
  flex-direction: column;
  margin-left: 50px;
}

.eye-and-link {
  display: flex;
  flex-direction: row;
  margin-top: 40px;
  margin-left: 65px;
}

.my-badges-link {
  font-size: 16px;
  line-height: 19.2px;
  text-decoration: underline;
}

.progressBoxText-unit {
  font-size: 12px;
  line-height: 14px;
  margin-top: -16px;
  margin-bottom: 3px;
  margin-left: -3px;
  color: #1e1e1e;
}

.unit-complete-progress {
  width: 648px;
}

.unit-progress-section {
  display: flex;
}

.title-box-area {
  background-color: lightblue;
}

.accordionPlus {
  height: 8px;
  width: 8px;
  text-align: left;
  padding: 0;
  margin-left: -39px;
  margin-top: 4px;
  transform: rotate(-90deg);
  cursor: pointer;
}

// .badges-modal-class .modal-backdrop {
//   background-color: transparent !important;
// }

// .badges-modal-class .modal-dialog {
//   height: 484px;
//   max-width: 640px;
//   position: fixed;
//   left: 130px;
// }

// .badges-modal-class .modal-content {
//   overflow: auto;
// }
//push

.modal {
  position: fixed;
  top: 92px;
  left: 110px;
  background: rgba(0, 0, 0, 0);
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 90px 22px 0px 22px;
  width: 648px;
  height: 484px;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-content: center;
}

.select-option {
  background-color: #fff;
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 9998;
}

#mainPage {
  position: relative;
}

#mainPage.grayed-out::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 9990;
  pointer-events: none;
  width: 100vw;
  height: 100vh;
}
</style>

